import type { ApiEnvelope } from '../../domain/types';
import type { HttpClientOptions, IOpenAiClient, ProviderConnectionProbe, UserSettingsPublic } from './types';
import { createHttpTransport, type HttpTransport } from './httpTransport';
import { parseEnvelope } from './parseEnvelope';

export class HttpOpenAiClient implements IOpenAiClient {
  private readonly transport: HttpTransport;
  constructor(options: HttpClientOptions = {}) { this.transport = createHttpTransport(options); }
  private async request<T>(path: string, init?: RequestInit): Promise<ApiEnvelope<T>> {
    const response = await this.transport.fetch(path, init);
    return parseEnvelope<T>(response, undefined, 'OPENAI_HTTP_ERROR');
  }
  startOAuth(): Promise<ApiEnvelope<{ authorizeUrl: string }>> { return this.request('/api/openai/oauth/start'); }
  disconnectOAuth(): Promise<ApiEnvelope<UserSettingsPublic>> { return this.request('/api/openai/oauth/disconnect', { method: 'POST' }); }
  testConnection(): Promise<ApiEnvelope<ProviderConnectionProbe>> { return this.request('/api/ai/connection/test/openai-codex', { method: 'POST' }); }
}
